import { render, staticRenderFns } from "./verb-som-styr-dativ.vue?vue&type=template&id=2a7ad838&scoped=true"
import script from "./verb-som-styr-dativ.vue?vue&type=script&lang=js"
export * from "./verb-som-styr-dativ.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a7ad838",
  null
  
)

export default component.exports